<!--
 * @Author: wjc
 * @Date: 2025-06-18 09:09:53
 * @LastEditors: wjc
 * @LastEditTime: 2025-09-28 15:08:24
 * @Description: 
-->
<template>
  <TooltipProvider :delay-duration="delayDuration">
    <Tooltip>
      <TooltipTrigger as-child tabindex="-1">
        <slot name="trigger"></slot>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent
          :class="contentClass"
          :side="side"
          :style="contentStyle"
          class="side-content text-popover-foreground rounded-md"
        >
          <slot></slot>
          <TooltipArrow v-if="arrow" :width="12" :height="6" />
        </TooltipContent>
      </TooltipPortal>
    </Tooltip>
  </TooltipProvider>
</template>

<script setup lang="ts">
  import type { TooltipContentProps } from 'reka-ui'

  import type { StyleValue } from 'vue'

  import { TooltipPortal } from 'reka-ui'

  import {
    Tooltip,
    TooltipArrow,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
  } from './components'

  interface Props {
    arrow?: boolean
    contentClass?: Array<object | string> | object | string
    contentStyle?: StyleValue
    delayDuration?: number
    side?: TooltipContentProps['side']
  }

  withDefaults(defineProps<Props>(), {
    delayDuration: 0,
    side: 'right',
    contentClass: '',
    contentStyle: '',
    arrow: true,
  })
</script>
